export const MARKETING_EVENTS = {
  SONICBOX_LOADED: "sonicbox_loaded",
  VOTE_SUCCESS: "vote_success",
  REQUEST_SUCCESS: "request_success",
  TASK_COMPLETED: "task_completed",
  REDEEM_SUCCESS: "redeem_success",
  SLOT_VISIBLE: "slot_visible",
};

const listeners = new Set();

export const emitMarketingEvent = (name, payload = {}) => {
  if (!name) return;

  listeners.forEach((listener) => {
    try {
      listener({ name, payload, occurredAt: Date.now() });
    } catch (error) {
      console.log("marketing event listener error", error);
    }
  });
};

export const subscribeMarketingEvent = (listener) => {
  if (typeof listener !== "function") {
    return () => {};
  }

  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
